export default {
  situationWarning: {
    title: 'Renseignez les informations manquantes ci-dessous pour améliorer la pertinence de notre conseil',
    btnText: 'fiabiliser mes informations',
  },
  noDisposition: {
    title: 'Aucune disposition renseignée',
    subtitle:
      'Afin de bénéficier d\'un conseil optimal pour votre Transmission, veuillez renseigner les dispositions déjà consenties en faveur de vos proches.',
    add: 'Ajouter',
    why: 'Pourquoi ces données sont nécessaires ?',
    details:
      'Les dispositions déjà consenties en faveur de vos proches peuvent avoir un impact direct sur la répartition et le coût de la transmission.',
  },
}
